<div class="flex flex-col gap-6 w-full">
  <p class="text-xl">Zoho Setup</p>

  <!-- Projects grid -->
  <div class="flex flex-col gap-2">
    <p class="text-base font-semibold text-gray-700">Projects</p>

    @if (isLoadingProjects()) {
      <div class="flex justify-center items-center py-8">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <div class="table-container">
        <table mat-table [dataSource]="projects()" class="w-full">

          <ng-container matColumnDef="projectNo">
            <th mat-header-cell *matHeaderCellDef class="w-32">Project No</th>
            <td mat-cell *matCellDef="let row" class="w-32 text-gray-500">{{ row.ProjectNo }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let row">{{ row.Title }}</td>
          </ng-container>

          <ng-container matColumnDef="zohoProjectId">
            <th mat-header-cell *matHeaderCellDef class="w-72">Zoho Project</th>
            <td mat-cell *matCellDef="let row" class="w-72 py-1" (click)="$event.stopPropagation()">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:280px" class="compact-select">
                <input matInput #projectInput #projectTrigger="matAutocompleteTrigger"
                  [value]="getZohoProjectName(row.ZohoProjectId)"
                  [disabled]="isLoadingZohoProjects()"
                  placeholder="Select project..."
                  (input)="onProjectInput($event)"
                  (blur)="projectInput.value = getZohoProjectName(row.ZohoProjectId); zohoProjectSearch.set('')"
                  (keydown.tab)="onProjectTabKey($event, projectTrigger, row, projectInput)"
                  [matAutocomplete]="projectAuto"
                />
                <mat-autocomplete #projectAuto
                  (optionSelected)="onProjectSelected(row, $event)"
                >
                  <mat-option [value]="null">— None —</mat-option>
                  @for (zp of filteredZohoProjects(); track zp.project_id) {
                    <mat-option [value]="zp.project_id">{{ zp.project_name }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="projectColumns; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: projectColumns"
            class="cursor-pointer"
            [class.selected-row]="selectedProject()?.ProjectNo === row.ProjectNo"
            (click)="selectProject(row)"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell py-4 text-center text-gray-500" colspan="3">No projects found.</td>
          </tr>
        </table>
      </div>
    }
  </div>

  <!-- Phases grid -->
  <div class="flex flex-col gap-2">
    <p class="text-base font-semibold text-gray-700">
      Phases
      @if (selectedProject()) {
        <span class="font-normal text-gray-500"> — {{ selectedProject()!.Title }}</span>
      }
    </p>

    @if (isLoadingFeatures()) {
      <div class="flex justify-center items-center py-8">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else if (!selectedProject()) {
      <p class="text-gray-400 py-4">Select a project to view its phases.</p>
    } @else {
      <div class="table-container">
        <table mat-table [dataSource]="features()" class="w-full">

          <ng-container matColumnDef="phaseNo">
            <th mat-header-cell *matHeaderCellDef class="w-32">Phase No</th>
            <td mat-cell *matCellDef="let row" class="w-32 text-gray-500">{{ row.PhaseNo }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let row">{{ row.Title }}</td>
          </ng-container>

          <ng-container matColumnDef="zohoTaskId">
            <th mat-header-cell *matHeaderCellDef class="w-72">Zoho Task</th>
            <td mat-cell *matCellDef="let row" class="w-72 py-1" (click)="$event.stopPropagation()">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:280px" class="compact-select">
                <input matInput #taskInput #taskTrigger="matAutocompleteTrigger"
                  [value]="getZohoTaskName(row.ZohoTaskId)"
                  [disabled]="isLoadingZohoTasks() || !selectedProject()?.ZohoProjectId"
                  placeholder="Select task..."
                  (input)="onTaskInput($event)"
                  (blur)="taskInput.value = getZohoTaskName(row.ZohoTaskId); zohoTaskSearch.set('')"
                  (keydown.tab)="onTaskTabKey($event, taskTrigger, row, taskInput)"
                  [matAutocomplete]="taskAuto"
                />
                <mat-autocomplete #taskAuto
                  (optionSelected)="onTaskSelected(row, $event)"
                >
                  <mat-option [value]="null">— None —</mat-option>
                  @for (zt of filteredZohoTasks(); track zt.task_id) {
                    <mat-option [value]="zt.task_id">{{ zt.task_name }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="featureColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: featureColumns"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell py-4 text-center text-gray-500" colspan="3">No phases found for this project.</td>
          </tr>
        </table>
      </div>
    }
  </div>
</div>
